const getLocaleByGeoIP = cb => {
  if (typeof fetch !== "undefined") {
    fetch("/geo/default.json")
      .then(res => res.json())
      .then(data => {
        if (typeof window != "undefined") window.locale = data.acc_geo;
        cb(data.acc_geo);
      })
      .catch(err => console.warn("ERROR in HBS getLocaleByGeoIP: ", err));
  } else {
    return null;
  }
};

export default getLocaleByGeoIP;



// WEBPACK FOOTER //
// ./src/assets/js/getLocaleByGeoIP.js